__turbopack_context__.v({
  "applyButton": "Yo4feG_applyButton",
  "applyField": "Yo4feG_applyField",
  "applyFieldError": "Yo4feG_applyFieldError",
  "applyFieldLabel": "Yo4feG_applyFieldLabel",
  "applyForm": "Yo4feG_applyForm",
  "applyInput": "Yo4feG_applyInput",
  "applyRow": "Yo4feG_applyRow",
  "applySubmitButton": "Yo4feG_applySubmitButton",
  "applySuccess": "Yo4feG_applySuccess",
  "badge": "Yo4feG_badge",
  "badgeLocation": "Yo4feG_badgeLocation",
  "inputError": "Yo4feG_inputError",
  "jobBadges": "Yo4feG_jobBadges",
  "jobCard": "Yo4feG_jobCard",
  "jobCardButton": "Yo4feG_jobCardButton",
  "jobCardContent": "Yo4feG_jobCardContent",
  "jobCompany": "Yo4feG_jobCompany",
  "jobDetailActions": "Yo4feG_jobDetailActions",
  "jobDetailBody": "Yo4feG_jobDetailBody",
  "jobDetailCol": "Yo4feG_jobDetailCol",
  "jobDetailCompany": "Yo4feG_jobDetailCompany",
  "jobDetailHeader": "Yo4feG_jobDetailHeader",
  "jobDetailLabel": "Yo4feG_jobDetailLabel",
  "jobDetailList": "Yo4feG_jobDetailList",
  "jobDetailRow": "Yo4feG_jobDetailRow",
  "jobDetailSection": "Yo4feG_jobDetailSection",
  "jobDetailSectionTitle": "Yo4feG_jobDetailSectionTitle",
  "jobDetailTitle": "Yo4feG_jobDetailTitle",
  "jobIntro": "Yo4feG_jobIntro",
  "jobPostingsContainer": "Yo4feG_jobPostingsContainer",
  "jobPostingsHeading": "Yo4feG_jobPostingsHeading",
  "jobPostingsList": "Yo4feG_jobPostingsList",
  "jobShortDesc": "Yo4feG_jobShortDesc",
  "jobTitle": "Yo4feG_jobTitle",
  "modal": "Yo4feG_modal",
  "modalClose": "Yo4feG_modalClose",
  "modalOverlay": "Yo4feG_modalOverlay",
  "resumeFileName": "Yo4feG_resumeFileName",
  "resumeInput": "Yo4feG_resumeInput",
  "resumeUpload": "Yo4feG_resumeUpload",
  "resumeUploadButton": "Yo4feG_resumeUploadButton",
});
